import {css} from "@emotion/react";
import styled from "@emotion/styled";

const editDeployment = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 50px;
  height: fit-content;
`

export const EditDeploymentWrapper = styled.div`
  ${editDeployment}
`
